import { Dashboard } from "./components/dashboard";
import { createSignal, type Component, Show, onMount, Switch, Match } from "solid-js";
import { getPluginService } from "./services/plugin/plugin-service";
import { PageRenderer } from "./components/page-renderer";
import { type PageIdentifier, type PluginEntry } from "./types";

export const App: Component = () => {
  const [currentPage, setCurrentPage] = createSignal<PageIdentifier | null>(null);
  const [pluginEntries, setPluginEntries] = createSignal<Array<PluginEntry>>([], {});

  onMount(async () => {
    getPluginService().addChangeListener((e) => {
      setPluginEntries(e);
    });
  });

  const goBack = () => setCurrentPage(null);
  const pluginEntry = () =>
    currentPage() === null ? null : (pluginEntries().find((pE) => pE.id === currentPage()) ?? null);

  return (
    <div>
      <Switch>
        <Match when={currentPage()}>
          <PageRenderer
            pageId={currentPage()}
            pluginEntry={pluginEntry()}
            pluginEntries={pluginEntries()}
            onBack={goBack}
          />
        </Match>
        <Match when={!currentPage()}>
          <Dashboard pluginEntries={pluginEntries()} onNavigate={setCurrentPage} />
        </Match>
      </Switch>
    </div>
  );
};
